module.exports = __webpack_public_path__ + "img/mysql.ac4d19b.svg";